import Api from '../../common/api/api';
import responsePayloadMixin from '../../common/api/response-payload-mixin';


class U14Api extends responsePayloadMixin(Api) {}


export default U14Api;

